import { render, staticRenderFns } from "./header-search-box.vue?vue&type=template&id=55d19afe&scoped=true&"
import script from "./header-search-box.vue?vue&type=script&lang=ts&"
export * from "./header-search-box.vue?vue&type=script&lang=ts&"
import style0 from "./header-search-box.vue?vue&type=style&index=0&id=55d19afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d19afe",
  null
  
)

export default component.exports